<template>
  <q-page class="flex column page-layout game-assets">
    <DropboxEmbed :url="link" />
  </q-page>
</template>

<script>
import DropboxEmbed from "@/components/other/DropboxEmbed.vue";

export default {
  name: "GameAssets",
  data() {
    return {
      link:
        "https://www.dropbox.com/sh/cf4n7de6udcxu83/AACG8xyTzLiHSgj76PcwiCh2a?dl=0",
    };
  },
  components: {
    DropboxEmbed,
  },
};
</script>
<style lang="scss" scoped>
.game-assets {
  height: calc(100vh - 60px);
}
</style>
